import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import BaseFacet from '../BaseFacet/BaseFacet';
import FacetType from '../../../utility/types/facetType';
import { facetTypeDetails } from '../../../utility/types/facetTypeDetails';

/* istanbul ignore next */
class DeviceFirmwareStatusFacet extends BaseFacet {
  constructor() {
    super();
    this.facetType = FacetType.DEVICE_FIRMWARE_STATUS;
    this.displayName = 'Device Firmware Status';
    this.description = 'Include devices that are...';
  }

  // eslint-disable-next-line class-methods-use-this
  getOperatorDescription(operatorType) {
    const operatorTypeId = parseInt(operatorType, 10);
    const operatorDescriptions = {
      [OperatorTypes.EQUAL_TO_VALUE]: 'Running Current Firmware',
      [OperatorTypes.NOT_EQUAL_TO]: 'Running Old Firmware',
    };
    return operatorDescriptions[operatorTypeId] || '';
  }

  // eslint-disable-next-line class-methods-use-this
  getDisplayValue1() {
    return '';
  }

  // eslint-disable-next-line class-methods-use-this
  fromDisplayValue1() {
    return 1;
  }

  getOperatorSelectOptions() {
    const facet = facetTypeDetails[this.facetType];
    return [
      {
        value: facet.validOperators[0],
        label: this.getOperatorDescription(facet.validOperators[0]),
      },
      {
        value: facet.validOperators[1],
        label: this.getOperatorDescription(facet.validOperators[1]),
      },
    ];
  }

  // eslint-disable-next-line class-methods-use-this
  getTooltip(filtersByOperatorObj) {
    if (filtersByOperatorObj && Object.values(filtersByOperatorObj).length) {
      const filtersArray = Object.values(filtersByOperatorObj)[0];
      const filter = filtersArray[0];
      return `Device is ${this.getOperatorDescription(filter.operatorId)}`;
    }
    return '';
  }
}
export default DeviceFirmwareStatusFacet;
